import { Injectable } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Module } from '@library/store/modules/modules.interface';
import { Room } from '@library/store/rooms/rooms.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { sortModulesByTypes } from '@pages/control-page/control-page-helper';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import { ENERGY_TEMPERATURE_MODULES, FAVORITE_TEMPERATURE_MODULES, TEMPERATURE_MODULES, WEATHER_TEMPERATURE_MODULES } from '@pages/control-page/control-page.const';
import { combineLatest, map, startWith, withLatestFrom } from 'rxjs';

@Injectable()
export class RoomTemperatureService {

  display$ = this.sidebarRoomService.roomModules$.pipe(
    withLatestFrom(this.homesfacade.currentHome$),
    map(([modules, home]) => {
      if (home.mode !== 'favorite') {
        return modules.map(m => m.type).some(type => TEMPERATURE_MODULES.includes(type));
      }
      else {
        return modules.map(m => m.type).some(type => FAVORITE_TEMPERATURE_MODULES.includes(type));
      }
    }),
  );

  module$ = this.sidebarRoomService.roomModules$.pipe(
    withLatestFrom(this.homesfacade.currentHome$),
    map(([modules, home]) => {
      if (home.mode !== 'favorite') {
        return sortModulesByTypes(modules, TEMPERATURE_MODULES)
          .find(m => TEMPERATURE_MODULES.includes(m.type));
      }
      else {
        return modules.find(m => FAVORITE_TEMPERATURE_MODULES.includes(m.type));
      }
    })
  );

  unreachable$ = combineLatest({
    module: this.module$.pipe(isDefined()),
    modules: this.modulesFacade.modules$,
  }).pipe(
    map(({module, modules}) => this.sidebarRoomService.isUnreachable(module, modules)),
    startWith(false)
  );

  constructor(
    private sidebarRoomService: SidebarRoomService,
    private homesfacade: HomesFacade,
    private modulesFacade: ModulesFacade,
  ) {}

  getTemperatureDisplay(module: Module, room: Room) {
    if (WEATHER_TEMPERATURE_MODULES.includes(module.type)) {
      return module.Temperature;
    }
    else if (ENERGY_TEMPERATURE_MODULES.includes(module.type)) {
      return room.therm_measured_temperature;
    }

    return null;
  }

}